import { Source } from "trader.ts/types/source";
import { Field } from "trader.ts/ui.forms";

export function constantFieldWithRender<T>(
  t: T,
  h: HTMLElement | HTMLElement[],
): Promise<Field<T>> {
  const s = new Source({ tag: "parsed" as const, parsed: t });
  return Promise.resolve({
    s,
    cleanup: () => {},
    render: () => {
      return h;
    },
  });
}
